import {useContext} from 'react'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import MoleculeModal from '@s-ui/react-molecule-modal'
import MoleculeNotification, {
  moleculeNotificationAlignItems,
  moleculeNotificationBorderSizes,
  moleculeNotificationTypes,
  moleculeNotificationVariations
} from '@s-ui/react-molecule-notification'
import {useLocation} from '@s-ui/react-router'
import ModalBasicContent from '@adv-mt/mt-modal-basic-content'
import IconCircleCheck from '@adv-mt/mt-svg-icons/lib/CircleCheck.js'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'

import {useMessagingContext} from '../../useMessagingContext/index.js'

export const RejectedPriceTransactionModal = () => {
  const {state: routerState} = useLocation()
  const {i18n} = useContext(Context)
  const {setInteractionComponent} = useMessagingContext()

  const {adPrice, sellerName} = routerState || {}

  return (
    <MoleculeModal
      isOpen
      closeOnOutsideClick
      closeOnEscKeyDown
      iconClose={<IconClose size={ATOM_ICON_SIZES.medium} />}
      onClose={() => setInteractionComponent({component: null, show: false})}
    >
      <div className="mt-TransactionRejectedPriceModal-modalContainer">
        <MoleculeNotification
          alignItems={moleculeNotificationAlignItems.CENTER}
          autoClose={null}
          icon={<IconCircleCheck size="medium" />}
          position="relative"
          roundedCorners={moleculeNotificationBorderSizes.medium}
          show
          showCloseButton={false}
          showLeftIconMobile
          type={moleculeNotificationTypes.error}
          variation={moleculeNotificationVariations.positive}
        >
          {i18n.t(`COMMON.REJECTED_PRICE`)}
        </MoleculeNotification>
        <ModalBasicContent
          stepsContent={[
            {
              buttons: {
                confirmButton: {
                  customCallBack: () => {
                    setInteractionComponent({component: null, show: false})
                  },
                  text: i18n.t('COMMON.UNDERSTOOD')
                }
              },
              children: (
                <div className="mt-TransactionRejectedPriceModal-modalChildren">
                  <div className="mt-TransactionRejectedPriceModal-description">
                    {i18n.t('VEHICLE_TRANSACTION.REJECTED_PRICE.MODAL_TEXT', {sellerName})}
                  </div>
                  <div className="mt-TransactionRejectedPriceModal-priceWrapper">
                    <div className="mt-TransactionRejectedPriceModal-adPrice">
                      <span className="mt-TransactionRejectedPriceModal-adPriceLabel">
                        {i18n.t('VEHICLE_TRANSACTION.REJECTED_PRICE.AD_PRICE')}
                      </span>
                      <span className="mt-TransactionRejectedPriceModal-adPriceValue">{i18n.c(adPrice)}</span>
                    </div>
                    <div className="mt-TransactionRejectedPriceModal-agreedPrice">
                      <span className="mt-TransactionRejectedPriceModal-agreedPriceLabel">
                        {i18n.t('VEHICLE_TRANSACTION.REJECTED_PRICE.AGREED_PRICE')}
                      </span>
                      <span className="mt-TransactionRejectedPriceModal-agreedPriceValue">-</span>
                    </div>
                  </div>
                </div>
              ),
              title: i18n.t('VEHICLE_TRANSACTION.REJECTED_PRICE.MODAL_TITLE'),
              titleMarginBottom: 'l'
            }
          ]}
        />
      </div>
    </MoleculeModal>
  )
}
